const INVOICE_CHARGES = [
    ['ConsultationFee', 'Consultation Fee'],
    ['LabInvestigationFee', 'Lab Investigation Fee'],
    ['PharmacyFee', 'Pharmacy Fee'],
    ['OtherCharges', 'Other Charges'],
];

const InvoiceDetails = ({ customerCardNumber, customerName, formatDate, hospitalName, invoice, onDownload }) => {
    if (!invoice) {
        return null;
    }

    return (
        <div className="container mb-5 px-3 px-md-5">
            <div className="card p-4" style={{ borderRadius: '16px', backgroundColor: '#fdfdfd' }}>
                <div className="text-center mb-4 border-bottom pb-3">
                    <h2 className="fw-bold text-primary mb-1">{hospitalName}</h2>
                    <p className="text-muted mb-0" style={{ fontSize: '0.95rem' }}>Invoice Date: {formatDate(invoice.CreatedDate)}</p>
                </div>
                <div className="mb-4">
                    <h6 className="fw-bold border-bottom pb-2 mb-3">Patient Details</h6>
                    <div className="mb-2"><strong>Name:</strong> {customerName}</div>
                    <div className="mb-2"><strong>Card Number:</strong> {customerCardNumber}</div>
                </div>
                <h6 className="fw-bold border-bottom pb-2 mb-3">Consultation Charges</h6>
                <div className="table-responsive">
                    <table className="table table-bordered mb-4">
                        <thead className="table-light">
                            <tr><th className="w-75">Description</th><th className="text-end">Amount (INR)</th></tr>
                        </thead>
                        <tbody>
                            {INVOICE_CHARGES.map(([field, label]) => invoice[field] && (
                                <tr key={field}><td>{label}</td><td className="text-end">₹{invoice[field]}</td></tr>
                            ))}
                            {invoice.DiscountPercentage && (
                                <tr><td>Discount</td><td className="text-end text-danger">- {invoice.DiscountPercentage}%</td></tr>
                            )}
                            <tr className="fw-bold bg-light"><td>Total</td><td className="text-end">₹{invoice.TotalAmount}</td></tr>
                            {invoice.PaidAmount && (
                                <tr className="fw-semibold"><td>Paid Amount</td><td className="text-end text-success">₹{invoice.PaidAmount}</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <p className="fst-italic small text-muted mb-4">
                    This invoice is generated for the consultation and related services provided to the patient. Please retain this invoice for your records.
                </p>
                <div className="text-end mb-3">
                    <button type="button" onClick={() => onDownload(invoice.InvoiceFileName)} className="btn btn-outline-primary">
                        <i className="bi bi-download me-2"></i>Download Invoice
                    </button>
                </div>
                <hr className="mb-3" />
                <p className="text-center text-muted small mb-0">
                    Thank you for choosing <strong>{hospitalName}</strong>. Wishing you a speedy recovery!
                </p>
            </div>
        </div>
    );
};

export default InvoiceDetails;
